/**
 * Product cards: desktop-only — alternate media + autoplay Shopify video / external iframe on hover.
 * Collection grids (Liquid) + Rebuy widget #rebuy-widget-109790 (fetches /products/{handle}.js).
 */
(function () {
    var REBUY_WIDGET_ID = 'rebuy-widget-109790';
    var PRODUCT_JSON_CACHE = Object.create(null);
    var PRODUCT_JSON_PENDING = Object.create(null);
    var REBUY_SCAN_TIMER;

    function prefersReducedMotion() {
        return (
            typeof window.matchMedia === 'function' &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches
        );
    }

    function canHoverSwap() {
        if (typeof window.matchMedia !== 'function') {
            return false;
        }
        if (!window.matchMedia('(min-width: 992px)').matches) {
            return false;
        }
        return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function productsJsonUrl(handle) {
        var root =
            (typeof window.Shopify !== 'undefined' &&
                window.Shopify.routes &&
                window.Shopify.routes.root) ||
            '/';
        if (root.slice(-1) !== '/') {
            root += '/';
        }
        return root + 'products/' + encodeURIComponent(handle) + '.js';
    }

    function fetchProductJson(handle) {
        if (!handle) {
            return Promise.resolve(null);
        }
        if (Object.prototype.hasOwnProperty.call(PRODUCT_JSON_CACHE, handle)) {
            return Promise.resolve(PRODUCT_JSON_CACHE[handle]);
        }
        if (PRODUCT_JSON_PENDING[handle]) {
            return PRODUCT_JSON_PENDING[handle];
        }
        PRODUCT_JSON_PENDING[handle] = fetch(productsJsonUrl(handle))
            .then(function (res) {
                if (!res.ok) {
                    throw new Error(res.statusText);
                }
                return res.json();
            })
            .then(function (product) {
                PRODUCT_JSON_CACHE[handle] = product;
                delete PRODUCT_JSON_PENDING[handle];
                return product;
            })
            .catch(function () {
                delete PRODUCT_JSON_PENDING[handle];
                return null;
            });
        return PRODUCT_JSON_PENDING[handle];
    }

    function getSecondDisplayableMedia(product) {
        if (!product) {
            return null;
        }
        var media = product.media;
        if (Array.isArray(media) && media.length > 1) {
            var m = media[1];
            if (m && m.media_type && m.media_type !== 'model') {
                return m;
            }
        }
        var images = product.images;
        if (Array.isArray(images) && images.length > 1) {
            var img = images[1];
            var src = typeof img === 'string' ? img : img && img.src;
            if (!src) {
                return null;
            }
            return { media_type: 'image', preview_image: { src: src } };
        }
        return null;
    }

    function ensureVideoMuted(video) {
        if (!video) {
            return;
        }
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
    }

    function sizedCdnImageSrc(src, width) {
        if (!src || typeof src !== 'string') {
            return '';
        }
        if (/[?&]width=/.test(src)) {
            return src;
        }
        return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
    }

    function buildRebuyHoverLayer(second) {
        if (!second || !second.media_type) {
            return null;
        }
        var span = document.createElement('span');
        span.className = 'rebuy-product-image__layer rebuy-product-image__layer--hover';
        span.setAttribute('aria-hidden', 'true');

        if (second.media_type === 'image') {
            var preview = second.preview_image || {};
            var src =
                preview.src ||
                second.src ||
                (preview && preview.url);
            if (!src) {
                return null;
            }
            var img = document.createElement('img');
            img.src = sizedCdnImageSrc(src, 640);
            img.alt = '';
            img.loading = 'lazy';
            span.appendChild(img);
            return span;
        }

        if (second.media_type === 'video') {
            var sources = second.sources || [];
            var mp4 =
                sources.find(function (s) {
                    return (
                        (s.format && String(s.format).indexOf('mp4') >= 0) ||
                        (s.mime_type && String(s.mime_type).indexOf('mp4') >= 0)
                    );
                }) || sources[0];
            if (!mp4 || !mp4.url) {
                return null;
            }
            var video = document.createElement('video');
            video.className = 'product-card-hover-video js-product-card-hover-video';
            ensureVideoMuted(video);
            video.setAttribute('playsinline', '');
            video.setAttribute('loop', '');
            video.setAttribute('preload', 'metadata');
            var sourceEl = document.createElement('source');
            sourceEl.src = mp4.url;
            sourceEl.type = mp4.mime_type || 'video/mp4';
            video.appendChild(sourceEl);
            span.appendChild(video);
            return span;
        }

        if (second.media_type === 'external_video') {
            var host = second.host;
            var id = second.external_id;
            var embedUrl = '';
            if (host === 'youtube' && id) {
                embedUrl =
                    'https://www.youtube-nocookie.com/embed/' +
                    encodeURIComponent(id) +
                    '?enablejsapi=1';
            } else if (host === 'vimeo' && id) {
                embedUrl =
                    'https://player.vimeo.com/video/' + encodeURIComponent(id);
            }
            if (!embedUrl) {
                return null;
            }
            var wrap = document.createElement('div');
            wrap.className = 'product-card-hover-external js-product-card-hover-external';
            var iframe = document.createElement('iframe');
            iframe.className = 'product-card-hover-iframe';
            iframe.setAttribute('src', embedUrl);
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allow', 'autoplay; encrypted-media');
            wrap.appendChild(iframe);
            span.appendChild(wrap);
            return span;
        }

        return null;
    }

    function attachHoverPlayHandlers(container) {
        if (!container || container.dataset.hoverPlayBound === '1') {
            return;
        }
        if (prefersReducedMotion()) {
            return;
        }
        var video = container.querySelector('.js-product-card-hover-video');
        var iframe = container.querySelector('.js-product-card-hover-external iframe');
        if (!video && !iframe) {
            return;
        }
        container.dataset.hoverPlayBound = '1';

        container.addEventListener('mouseenter', function () {
            if (!canHoverSwap()) {
                return;
            }
            if (video && typeof video.play === 'function') {
                ensureVideoMuted(video);
                video.play().catch(function () {});
            }
            if (iframe) {
                if (iframe.dataset.srcOrig === undefined) {
                    iframe.dataset.srcOrig = iframe.getAttribute('src') || '';
                }
                var base = iframe.dataset.srcOrig;
                if (!base) {
                    return;
                }
                if (/youtube\.com\/embed|youtube-nocookie\.com\/embed/i.test(base)) {
                    if (base.indexOf('autoplay=1') !== -1) {
                        return;
                    }
                    var sep = base.indexOf('?') >= 0 ? '&' : '?';
                    iframe.setAttribute('src', base + sep + 'autoplay=1&mute=1&playsinline=1');
                } else if (/player\.vimeo\.com\/video/i.test(base)) {
                    if (base.indexOf('autoplay=1') !== -1) {
                        return;
                    }
                    var sepv = base.indexOf('?') >= 0 ? '&' : '?';
                    iframe.setAttribute('src', base + sepv + 'autoplay=1&muted=1&playsinline=1');
                }
            }
        });

        container.addEventListener('mouseleave', function () {
            if (video && typeof video.pause === 'function') {
                video.pause();
                try {
                    video.currentTime = 0;
                } catch (e) {}
            }
            if (iframe && iframe.dataset.srcOrig !== undefined) {
                iframe.setAttribute('src', iframe.dataset.srcOrig);
            }
        });
    }

    function bindWrapper(wrap) {
        if (wrap.dataset.productCardHoverInit === '1') {
            return;
        }
        if (!wrap.querySelector('a.product-grid-image--dual')) {
            return;
        }
        wrap.dataset.productCardHoverInit = '1';
        if (prefersReducedMotion()) {
            return;
        }
        attachHoverPlayHandlers(wrap);
    }

    function initProductCardHoverMedia() {
        document.querySelectorAll('.product-grid-item .image-wrapper').forEach(bindWrapper);
    }

    function processRebuyAnchor(anchor) {
        if (!anchor || !anchor.classList || !anchor.classList.contains('rebuy-product-image')) {
            return;
        }
        if (anchor.dataset.rebuyHoverSkip === '1') {
            return;
        }
        if (anchor.dataset.rebuyHoverEnhanced === '1') {
            if (anchor.querySelector('.rebuy-product-image__layer--hover')) {
                return;
            }
            delete anchor.dataset.rebuyHoverEnhanced;
        }
        if (anchor.dataset.rebuyHoverFetch === '1') {
            return;
        }
        var block = anchor.closest('[data-product-handle]');
        if (!block) {
            return;
        }
        var handle = block.getAttribute('data-product-handle');
        if (!handle) {
            return;
        }

        anchor.dataset.rebuyHoverFetch = '1';
        fetchProductJson(handle)
            .then(function (product) {
                delete anchor.dataset.rebuyHoverFetch;
                var second = getSecondDisplayableMedia(product);
                if (!second) {
                    anchor.dataset.rebuyHoverSkip = '1';
                    return;
                }
                var hoverLayer = buildRebuyHoverLayer(second);
                if (!hoverLayer) {
                    anchor.dataset.rebuyHoverSkip = '1';
                    return;
                }
                var existing = anchor.querySelector('.rebuy-product-image__layer--hover');
                if (existing) {
                    existing.remove();
                }
                var media = anchor.closest('.rebuy-product-media');
                if (media) {
                    delete media.dataset.hoverPlayBound;
                    delete anchor.dataset.hoverPlayBound;
                }
                anchor.appendChild(hoverLayer);
                anchor.classList.add('rebuy-product-image--dual');
                attachHoverPlayHandlers(anchor);
                anchor.dataset.rebuyHoverEnhanced = '1';
            })
            .catch(function () {
                delete anchor.dataset.rebuyHoverFetch;
            });
    }

    function scanRebuyProductImages() {
        var root = document.getElementById(REBUY_WIDGET_ID);
        if (!root) {
            return;
        }
        root.querySelectorAll('a.rebuy-product-image').forEach(processRebuyAnchor);
    }

    function scheduleRebuyScan() {
        clearTimeout(REBUY_SCAN_TIMER);
        REBUY_SCAN_TIMER = setTimeout(scanRebuyProductImages, 120);
    }

    function observeRebuyWidget() {
        var root = document.getElementById(REBUY_WIDGET_ID);
        if (!root || root.dataset.rebuyHoverObserve === '1') {
            return;
        }
        root.dataset.rebuyHoverObserve = '1';
        var obs = new MutationObserver(scheduleRebuyScan);
        obs.observe(root, { childList: true, subtree: true });
    }

    function initRebuyHoverMedia() {
        observeRebuyWidget();
        scanRebuyProductImages();
    }

    document.addEventListener('rebuy.ready', function (e) {
        var d = e && e.detail;
        var wid = d && d.widget && d.widget.id != null ? String(d.widget.id) : '';
        if (wid && wid !== '109790') {
            return;
        }
        scheduleRebuyScan();
        setTimeout(scanRebuyProductImages, 400);
        setTimeout(scanRebuyProductImages, 1200);
    });

    function boot() {
        initProductCardHoverMedia();
        initRebuyHoverMedia();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
    document.addEventListener('shopify:section:load', boot);
})();
